module.exports = new __parcel__URL__("key_technologies_2.429e4188.jpg").toString();